// extracted by mini-css-extract-plugin
module.exports = {"social":"footer-links_social__8LjAX","list":"footer-links_list__3r9dT","heading":"footer-links_heading__dZdV3","link":"footer-links_link__mjLnd"};